import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Persona } from 'src/app/models/personas.interface';

@Injectable({
  providedIn: 'root'
})
export class ManagePersonasData {
  private output = new Subject<PersonaComponentData>();
  getObservable() {
    return this.output.asObservable();
  }
  emitViewChange(personaComponentData: PersonaComponentData) {
    this.output.next(personaComponentData);
  }
}

export interface PersonaComponentData {
  componentName: string;
  persona?: Persona;
  personaTitles?: string[];
}
